import {
	BG,
	BA,
	BR,
	CZ,
	DE,
	DK,
	ES,
	EU,
	FI,
	FR,
	GR,
	HR,
	HU,
	IT,
	MK,
	MX,
	LT,
	LV,
	EE,
	NL,
	NO,
	PL,
	PT,
	RO,
	RS,
	SE,
	SI,
	SK,
	TR,
	US,
} from "country-flag-icons/react/3x2";
import { getLocaleConfig, type Locale } from "@/config/locale";
import { channelSlugToFlagIso } from "@/lib/flag-emoji";
import { cn } from "@/lib/utils";

const localeFlags: Record<Locale, typeof DE> = {
	en: US,
	de: DE,
	it: IT,
	es: ES,
	"es-mx": MX,
	fr: FR,
	nl: NL,
	pt: PT,
	"pt-br": BR,
	pl: PL,
	sv: SE,
	da: DK,
	el: GR,
	cs: CZ,
	fi: FI,
	ro: RO,
	hu: HU,
	sk: SK,
	tr: TR,
	nb: NO,
	bg: BG,
	hr: HR,
	sl: SI,
	sr: RS,
	bs: BA,
	mk: MK,
	lt: LT,
	lv: LV,
	et: EE,
};

const channelFlags = {
	EU,
	US,
} as const;

/**
 * SVG flag next to footer language select (matches current locale).
 */
export function FooterLocaleFlag({ locale, className }: { locale: Locale; className?: string }) {
	const Flag = localeFlags[locale];
	const label = getLocaleConfig(locale).nativeName;
	return (
		<span
			className={cn(
				"inline-flex shrink-0 overflow-hidden rounded-[3px] shadow-sm ring-1 ring-border",
				className,
			)}
			title={label}
			aria-hidden
		>
			<Flag className="block h-5 w-[30px]" />
		</span>
	);
}

/**
 * SVG flag for EU / US channel (Saleor storefront region).
 */
export function FooterChannelFlag({ channelSlug, className }: { channelSlug: string; className?: string }) {
	const iso = channelSlugToFlagIso(channelSlug);
	const Flag = channelFlags[iso];
	const label = iso === "US" ? "US" : "EU";
	return (
		<span
			className={cn(
				"inline-flex shrink-0 overflow-hidden rounded-[3px] shadow-sm ring-1 ring-border",
				className,
			)}
			title={label}
			aria-hidden
		>
			<Flag className="block h-5 w-[30px]" />
		</span>
	);
}
